import React from "react";
import {
	SortableContainer,
	SortableElement,
	sortableHandle,
} from "react-sortable-hoc";
import { FormLabel, FormControl } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import { WIDGET_NAMES } from "components/WidgetTemplates/utils";
import { useTranslation } from "react-i18next";

const DragHandle = sortableHandle(() => (
	<span className="column-move">
		<FiMenu className="column-move-icon" />
	</span>
));

const ColumnItem = SortableElement(({ item, domId, handleColumn }) => {
	let id = item.id;
	const { t } = useTranslation();

	const checked = item.checked || false;
	const name = t(WIDGET_NAMES[item.name]);

	return (
		<li aria-label={name} title={name} className="column-item">
			<div className="column-left checkbox">
				<input
					type="checkbox"
					id={`${domId}_checkbox_${id}`}
					onChange={(e) => handleColumn(item, e, { action: "select" })}
					checked={checked}
				/>
				<label htmlFor={`${domId}_checkbox_${id}`} className="btn-check-label">
					<span className="column-item-label">{name}</span>
				</label>
			</div>
			<div className="column-right">
				<div className="column-item-selectbox">
					<FormLabel htmlFor={`${domId}_width_${id}`}>Anchura</FormLabel>
					<FormControl
						id={`${domId}_width_${id}`}
						onChange={(e) =>
							handleColumn(item, e, { action: "edit", field: "width" })
						}
						value={item.width}
						as="select"
					>
						{[1, 2, 3, 4].map((number) => (
							<option key={number} value={number}>
								{number}
							</option>
						))}
					</FormControl>
				</div>
				<div className="column-item-selectbox">
					<FormLabel htmlFor={`${domId}_height_${id}`}>Altura</FormLabel>
					<FormControl
						id={`${domId}_height_${id}`}
						onChange={(e) =>
							handleColumn(item, e, { action: "edit", field: "height" })
						}
						value={item.height}
						as="select"
					>
						{[1, 2, 3, 4].map((number) => (
							<option key={number} value={number}>
								{number}
							</option>
						))}
					</FormControl>
				</div>

				<DragHandle />
			</div>
		</li>
	);
});

const ColumnList = SortableContainer(({ items, handleColumn, domId }) => {
	return (
		<ul className="list-columns">
			{items.map((item, index) => (
				<ColumnItem
					key={`${domId}-item-${item.id}`}
					handleColumn={handleColumn}
					sortIndex={index}
					index={index}
					item={item}
					domId={domId}
				/>
			))}
		</ul>
	);
});

export default ColumnList;
